import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  changesToOrders: {
    id: 'socketNotificationModal.changesToOrders',
    defaultMessage: 'Muutoksia tilauksiin',
  },
  clearMessages: {
    id: 'socketNotificationModal.clearMessages',
    defaultMessage: 'Tyhjennä viestit',
  },
  checkChangedOrderDetails: {
    id: 'socketNotificationModal.checkChangedOrderDetails',
    defaultMessage: 'Tarkasta muuttuneet tiedot tilaukselta siirtymällä työnäkymään',
  },
  followingDataChanged: {
    id: 'socketNotificationModal.followingDataChanged',
    defaultMessage: 'Seuraavia tietoja on muokattu',
  },
  goToJobView: {
    id: 'socketNotificationModal.goToJobView',
    defaultMessage: 'Siirry työnäkymään',
  },
  goToTowingRecordJobView: {
    id: 'socketNotificationModal.goToTowingRecordJobView',
    defaultMessage: 'Siirry kuormakirjan työnäkymään',
  },
  fromLabel: {
    id: 'socketNotificationModal.fromLabel',
    defaultMessage: 'Mistä: ',
  },
  orderTimeLabel: {
    id: 'socketNotificationModal.orderTimeLabel',
    defaultMessage: 'Tilauksen ajankohta: ',
  },
  makeAndModelLabel: {
    id: 'socketNotificationModal.makeAndModelLabel',
    defaultMessage: 'Merkki ja malli: ',
  },
  toLabel: {
    id: 'socketNotificationModal.toLabel',
    defaultMessage: 'Mihin: ',
  },
  jobMustBeFinishedInJobView: {
    id: 'socketNotificationModal.jobMustBeFinishedInJobView',
    defaultMessage: 'Huom! Työ lopetettava työnäkymässä',
  },
  noUnreadMessages: {
    id: 'socketNotificationModal.noUnreadMessages',
    defaultMessage: 'Ei lukemattomia viestejä',
  },
  close: {
    id: 'socketNotificationModal.close',
    defaultMessage: 'Sulje',
  },
  editedByUser: {
    id: 'socketNotificationModal.editedByUser',
    defaultMessage: 'Käyttäjä {editedBy} on muokannut kuormakirjaa seuraavasti:',
  },
  showOldData: {
    id: 'socketNotificationModal.showOldData',
    defaultMessage: 'Näytä vanhat tiedot',
  },
  hideOldData: {
    id: 'socketNotificationModal.hideOldData',
    defaultMessage: 'Piilota vanhat tiedot',
  },
  emptyValue: {
    id: 'socketNotificationModal.emptyValue',
    defaultMessage: '(tyhjä)',
  },
})
